import { Application, InstallmentLoan, Lease } from '../../gql/graphql';

// The active product's application substruct. Only fields common to both are
// reachable through the union; lease-only fields (employment, bank, options,
// contractSummaries) still require an explicit application.lease read.
export const getApplicationDetails = (application?: Application | null): Lease | InstallmentLoan | undefined =>
  application?.installmentLoan ?? application?.lease ?? undefined;
